import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import { IncomeExpenseSummarySkeleton } from "../../Components/SkeletonLoading";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
} from "../../Components/Styles/PageStyles";
import {
    IoMdTrendingUp,
    IoMdTrendingDown,
    IoMdCash,
    IoMdInformationCircleOutline,
    IoIosArrowForward,
} from "react-icons/io";
import {
    MdOutlinePayments,
    MdOutlineRestaurant,
    MdOutlineSecurity,
} from "react-icons/md";
import { BsBank2 } from "react-icons/bs";
import { GiPayMoney } from "react-icons/gi";
import { BiRupee } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import tw from "tailwind-styled-components";
import { IoChevronBackOutline } from "react-icons/io5";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";

const dueTypeReverseMap = Object.fromEntries(
    Object.entries(Config.dueType).map(([k, v]) => [v, k.replaceAll("_", " ")])
);

const IncomeAndExpenseDetails = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state.UserReducer.user);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const properties = useSelector((state) => state.PropertyReducer.property);
    const [selectedProperty, setSelectedProperty] = useState(property);
    const [apiData, setApiData] = useState([]);
    const [securityInHand, setSecurityInHand] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [modalTitle, setModalTitle] = useState("");
    const modalRef = useRef(null);

    const fetchFunction = async () => {
        let url = "client/pendingrent/month/daily";
        if (selectedProperty.id !== 0) {
            //params.append('propertyId', selectedProperty.id);
            url = `property/pendingrent/month/daily/${selectedProperty.id}`
        }
        const response = await axios.get(
            `${Config.apiUrl}/${url}`,
            {
                headers: {
                    authorization: "Bearer " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess) {
            setApiData(res.data?.data || []);
            setSecurityInHand(res.securityInHand || 0);
        }
    };

    const getError = () => { };

    const { isLoading, mutate: getListMutate, error, isRefetching } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        if (selectedProperty) {
            const handler = setTimeout(() => {
                getListMutate();
            }, 200);
            return () => clearTimeout(handler);
        }
    }, [selectedProperty, getListMutate]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setModalOpen(false);
            }
        };
        if (modalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalOpen]);

    const openModal = (title, data) => {
        setModalTitle(title);
        setModalData(data);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setModalData(null);
    };

    const handleBackClick = () => {
        navigate("/dashboard");
    };

    const handlePropertySelect = (property) => {
        setSelectedProperty(property);
    };
    return (
        <BoxContainer>
            <BoxHead >
                <BoxTitle className="!mb-6 whitespace-nowrap">
                    <BackWrapper>
                        <BackButton onClick={handleBackClick}>
                            <IoChevronBackOutline size={20} />
                        </BackButton>
                        <div >
                            <span className="flex items-center"> Income & Expense Summary</span>
                            <Underline />
                        </div>
                    </BackWrapper>
                </BoxTitle>

                {/* <div className="flex cursor-pointer px-4 rounded-lg text-blue-500 text-sm items-center" onClick={() => navigate("/props-financial-summary")}>
                    {"Property-wise summary"}
                    <IoIosArrowForward
                        size={12}
                        className="ml-1 mt-0.5"
                    />
                </div> */}
                <PropertiesFilterDropdown
                    properties={properties}
                    selectedProperty={selectedProperty}
                    onPropertySelect={handlePropertySelect}
                    placeholder="All Properties"
                    className="w-full md:w-[200px]"
                />
            </BoxHead>

            {(isLoading || isRefetching) && <IncomeExpenseSummarySkeleton />}

            {/* {!error && !isLoading && apiData.length > 0 && (
                <div className=" grid gap-6">
                    {apiData.map((item, idx) => (
                        <div
                            key={idx}
                            className="rounded-2xl border border-gray-200 overflow-hidden"
                        >
                            <div className="bg-gray-200 px-4 pt-4 pb-4">
                                <div className=" text-gray-800  flex sm:flex-row flex-col sm:justify-between sm:items-center gap-4">
                                    <div>
                                        <h2 className="text-base sm:text-lg font-semibold">
                                            {getMonthName(item.month)} {item.year}
                                        </h2>
                                        <p className="text-xs sm:text-sm text-gray-600">
                                            {item.dueTenantCount} tenant(s) haven't paid their dues yet.
                                        </p>
                                    </div>
                                    <div className="flex flex-col items-end">
                                        <h2 className={`text-base sm:text-lg font-semibold ${item.netProfitLoss >= 0
                                            ? " text-green-700"
                                            : " text-red-700"
                                            }`}>
                                            {'₹' + Math.abs(item.netProfitLoss).toLocaleString() + ' (' + (item.totalIncome > 0 ? ((item.netProfitLoss / item.totalIncome) * 100).toFixed(1) + '%' : '0%') + ')'}
                                        </h2>
                                        <button
                                            onClick={() =>
                                                navigate(`/daily-summary/${selectedProperty.id}?m=${item.month}&y=${item.year}`)
                                            }
                                            className="flex items-center gap-1 text-gray-600 hover:text-primary-color text-xs"
                                        >
                                            Day Wise
                                            <IoIosArrowForward className="text-xs mt-0" />
                                        </button>

                                    </div>
                                </div>

                            </div>

                            <Section>
                                <Column>
                                    <SectionTitle title="Income Overview" color="green-500" />
                                    <div className="grid grid-cols-2 gap-3 text-base">
                                        <Stat
                                            icon={<IoMdTrendingUp className="text-green-500 text-xl" />}
                                            label="Total Income"
                                            value={item.totalIncome}
                                            color="text-green-700"
                                        />
                                        <Stat
                                            icon={<BiRupee className="text-blue-500 text-xl" />}
                                            label="Rent Received"
                                            value={item.totalRent}
                                        />

                                        <Stat
                                            icon={<MdOutlineSecurity className="text-indigo-500 text-xl" />}
                                            label="Security"
                                            value={item.totalSecurity}
                                        />

                                        <Stat
                                            icon={<IoMdCash className="text-teal-500 text-xl" />}
                                            label={
                                                <>
                                                    Other Income{" "}
                                                    <InfoIcon
                                                        onClick={() =>
                                                            openModal("Other Income Details", item.otherOnDate)
                                                        }
                                                    />
                                                </>
                                            }
                                            value={item.otherIncome || 0}
                                        />

                                        <Stat
                                            icon={<BsBank2 className="text-purple-500 text-xl" />}
                                            label="Received Online"
                                            value={item.totalOnline}
                                        />
                                        <Stat
                                            icon={<MdOutlinePayments className="text-yellow-600 text-xl" />}
                                            label="Received Cash"
                                            value={item.totalOffline}
                                        />
                                        <Stat
                                            icon={<GiPayMoney className="text-pink-500 text-xl" />}
                                            label="Kipinn App"
                                            value={item.totalPayu}
                                        />
                                    </div>
                                </Column>

                                <Column>
                                    <SectionTitle title="Expense Overview" color="red-500" />
                                    <div className="grid grid-cols-2 gap-3 text-sm">
                                        <Stat
                                            icon={<IoMdTrendingDown className="text-red-500 text-xl" />}
                                            label="Total Expense"
                                            value={item.totalExpense}
                                            color="text-red-700"
                                        />
                                        <Stat
                                            icon={<BiRupee className="text-orange-500 text-xl" />}
                                            label="Rent & Utilities"
                                            value={item.totalBuildingRentExpense}
                                        />
                                        <Stat
                                            icon={<MdOutlineRestaurant className="text-yellow-500 text-xl" />}
                                            label="Food / Kitchen"
                                            value={item.totalFoodExpense}
                                        />
                                        <Stat
                                            icon={<MdOutlinePayments className="text-sky-600 text-xl" />}
                                            label="Staff / Salary"
                                            value={item.totalStaffSalaryExpense}
                                        />

                                        <Stat
                                            icon={<IoMdCash className="text-gray-500 text-xl" />}
                                            label={
                                                <>
                                                    Other Expenses{" "}
                                                    <InfoIcon
                                                        onClick={() =>
                                                            openModal("Other Expense Details", item.otherExpenseOnDate)
                                                        }
                                                    />
                                                </>
                                            }
                                            value={item.otherExpense}
                                        />
                                        <Stat
                                            icon={<MdOutlinePayments className="text-red-400 text-xl" />}
                                            label="Pending Dues"
                                            value={item.totalDues}
                                        />
                                        <Stat
                                            icon={<GiPayMoney className="text-green-400 text-xl" />}
                                            label="Refunds"
                                            value={item.totalRefund}
                                        />
                                    </div>
                                </Column>
                            </Section>
                        </div>
                    ))}
                </div>
            )
            } */}

            {!error && !isLoading && apiData.map((item, idx) => (
                <div className="flex flex-col gap-8">
                    {apiData.map((item, idx) => (
                        <MonthlyFinancialCard
                            key={idx}
                            item={item}
                            selectedProperty={selectedProperty}
                            navigate={navigate}
                            openModal={openModal}
                        />
                    ))}
                </div>

            ))}


            {
                modalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
                        <div
                            ref={modalRef}
                            className="bg-white rounded-2xl w-full max-w-md shadow-lg p-6 relative animate-fadeIn"
                        >
                            <h2 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">
                                {modalTitle}
                            </h2>

                            {modalData && Object.keys(modalData).length > 0 ? (
                                <div className="max-h-60 overflow-y-auto space-y-2">
                                    {Object.entries(modalData).map(([key, value]) => {
                                        const label =
                                            dueTypeReverseMap[key] || key;
                                        return (
                                            <div
                                                key={key}
                                                className="flex justify-between items-center border-b border-gray-100 py-1"
                                            >
                                                <span className="text-gray-600 text-sm">{label}</span>
                                                <span className="text-gray-800 font-medium text-sm">
                                                    ₹{Number(value).toLocaleString()}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <p className="text-gray-500 text-sm">No data available.</p>
                            )}

                            <button
                                onClick={closeModal}
                                className="mt-5 w-full bg-primary-color text-white rounded-lg py-2 font-semibold transition-all"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )
            }
        </BoxContainer >
    );
};

const MonthlyFinancialCard = ({
    item,
    selectedProperty,
    navigate,
    openModal,
}) => {
    const profit = item.netProfitLoss;
    const profitPercent =
        item.totalIncome > 0
            ? ((profit / item.totalIncome) * 100).toFixed(1)
            : 0;

    return (
        <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
            {/* HEADER */}
            <div className="bg-gray-100 px-5 py-4 flex justify-between items-center">
                <div>
                    <h2 className="text-lg font-semibold text-gray-800">
                        {getMonthName(item.month)} {item.year}
                    </h2>
                    <p className="text-xs text-gray-600">
                        {item.dueTenantCount} tenants have pending dues
                    </p>
                </div>

                <button
                    onClick={() =>
                        navigate(
                            `/daily-summary/${selectedProperty.id}?m=${item.month}&y=${item.year}`
                        )
                    }
                    className="text-xs text-gray-600 hover:text-primary-color"
                >
                    Day-wise →
                </button>
            </div>

            {/* KPI ROW */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-5">
                <FinanceCard title="Total Income" value={item.totalIncome} tone="success" />
                <FinanceCard title="Total Expense" value={item.totalExpense} tone="danger" />
                <FinanceCardWithSubLabel
                    title={profit >= 0 ? "Net Profit" : "Net Loss"}
                    value={profit}
                    subValue={profitPercent + '%'}
                    tone={profit >= 0 ? "success" : "danger"}
                />
                <FinanceCard title="Pending Dues" value={item.totalDues} tone="warning" />
            </div>

            {/* PROFIT / LOSS BANNER */}
            {/* <div
                className={`mx-5 mb-5 rounded-xl px-4 py-3 text-sm font-medium ${profit >= 0
                    ? "bg-green-50 text-green-800"
                    : "bg-red-50 text-red-800"
                    }`}
            >
                {profit >= 0 ? "Profit" : "Loss"} of{" "}
                <span className="font-semibold">
                    ₹{Math.abs(profit).toLocaleString()}
                </span>{" "}
                ({profitPercent}% of income)
            </div> */}

            {/* BREAKDOWNS */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 px-5 pb-5">
                <SummaryCard title="Income Breakdown">
                    <Row label="Rent Received" value={item.totalRent} />
                    <Row label="Security" value={item.totalSecurity} />
                    <Row
                        label="Other Income"
                        value={item.otherIncome}
                        info={() =>
                            openModal("Other Income Details", item.otherOnDate)
                        }
                    />
                    <Divider />
                    <Row label="Total Income" value={item.totalIncome} bold />
                </SummaryCard>

                <SummaryCard title="Expense Breakdown">
                    <Row label="Rent & Utilities" value={item.totalBuildingRentExpense} />
                    <Row label="Food / Kitchen" value={item.totalFoodExpense} />
                    <Row label="Staff / Salary" value={item.totalStaffSalaryExpense} />
                    <Row
                        label="Other Expenses"
                        value={item.otherExpense}
                        info={() =>
                            openModal("Other Expense Details", item.otherExpenseOnDate)
                        }
                    />
                    <Divider />
                    <Row label="Total Expense" value={item.totalExpense} bold />
                </SummaryCard>
            </div>

            {/* COLLECTION SUMMARY */}
            <div className="px-5 pb-5">
                <SummaryCard title="Collection Summary">
                    <Row label="Online Payments" value={item.totalOnline} />
                    <Row label="Cash Received" value={item.totalOffline} />
                    <Row label="Kipinn Payments" value={item.totalPayu} />
                    <Divider />
                    <Row
                        label="Total Collected"
                        value={item.totalOnline + item.totalOffline + item.totalPayu}
                        bold
                    />
                </SummaryCard>
            </div>

            {/* SECURITY ADJUSTMENT SUMMARY */}
            {item.totalSecurityAdjusted > 0 && (
                <div className="px-5 pb-5">
                    <SummaryCard title="Security Deposit Adjustment">
                        <Row
                            label="Adjusted Against Dues"
                            value={item.totalSecurityAdjusted}
                            bold
                        />
                        <p className="text-xs text-gray-500 mt-2">
                            Security deposit adjusted against rent or charges.
                        </p>
                    </SummaryCard>
                </div>
            )}


            {/* PENDING ACTION */}
            {/* {item.totalDues > 0 && (
                <div className="mx-5 mb-6 border border-red-200 bg-red-50 rounded-2xl p-4">
                    <p className="text-sm font-semibold text-red-700">
                        Pending Dues
                    </p>
                    <p className="text-2xl font-bold text-red-800 mt-1">
                        ₹{item.totalDues.toLocaleString()}
                    </p>
                    <p className="text-xs text-red-600 mt-1">
                        {item.dueTenantCount} tenants pending payment
                    </p>

                    <button
                        onClick={() =>
                            navigate(`/pending-dues/${selectedProperty.id}`)
                        }
                        className="mt-3 text-sm font-medium text-red-700 underline"
                    >
                        View & Follow Up →
                    </button>
                </div>
            )} */}
        </div>
    );
};

const FinanceCard = ({ title, value, tone }) => {
    const toneMap = {
        success: "text-green-700 bg-green-50",
        danger: "text-red-700 bg-red-50",
        warning: "text-orange-700 bg-orange-50",
    };

    return (
        <div className={`rounded-2xl border p-4 ${toneMap[tone] || ""}`}>
            <p className="text-xs text-gray-500">{title}</p>
            <p className="text-2xl font-semibold">
                ₹{Math.abs(value || 0).toLocaleString()}
            </p>
        </div>
    );
};

const FinanceCardWithSubLabel = ({ title, value, tone, subValue }) => {
    const toneMap = {
        success: "text-green-700 bg-green-50",
        danger: "text-red-700 bg-red-50",
        warning: "text-orange-700 bg-orange-50",
    };

    return (
        <div className={`rounded-2xl border p-4 ${toneMap[tone] || ""}`}>
            <p className="text-xs text-gray-500">{title}</p>
            <p className="text-2xl font-semibold">
                ₹{Math.abs(value || 0).toLocaleString()} 
                <span className="text-xs"> {"(" + subValue + ")"} </span>
            </p>
        </div>
    );
};

const SummaryCard = ({ title, children }) => (
    <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">
            {title}
        </h3>
        <div className="space-y-2">{children}</div>
    </div>
);

const Row = ({ label, value, bold, info }) => (
    <div className="flex justify-between items-center text-sm">
        <span className={`text-gray-600 ${bold ? "font-semibold" : ""}`}>
            {label}
            {info && (
                <button
                    onClick={info}
                    className="ml-1 text-blue-600 text-xs underline"
                >
                    details
                </button>
            )}
        </span>
        <span className={`text-gray-800 ${bold ? "font-semibold" : ""}`}>
            ₹{Number(value || 0).toLocaleString()}
        </span>
    </div>
);

const Divider = () => (
    <div className="border-t border-gray-200 my-2" />
);

const SecurityRow = ({ label, value, tone, bold }) => {
    const toneMap = {
        neutral: "text-gray-700",
        negative: "text-red-600",
        positive: "text-green-700",
    };

    return (
        <div className="flex justify-between items-center text-sm">
            <span className={`text-gray-600 ${bold ? "font-medium" : ""}`}>
                {label}
            </span>

            <span
                className={`${toneMap[tone]} ${bold ? "font-semibold" : "font-medium"
                    }`}
            >
                {tone === "negative" ? "−" : ""}
                ₹{Math.abs(value || 0).toLocaleString()}
            </span>
        </div>
    );
};


const getMonthName = (month) => {
    const date = new Date();
    date.setMonth(month - 1);
    return date.toLocaleString("default", { month: "long" });
};

const BackWrapper = tw.div`flex items-center`;
const BackButton = tw.button`hover:bg-gray-200 items-center -mt-1 p-1 rounded-md transition-colors`;
const Column = tw.div`space-y-4`;
const Section = tw.div`grid grid-cols-1 sm:grid-cols-2 gap-4 p-5`
export default IncomeAndExpenseDetails;

